<app-mb-card>
  <header>
    <h2>Compañías</h2>
    <p>Aquí podrás administrar las compañías registradas en mBase. Podrás listar, añadir, editar o borrar compañías, así como dar de alta productos y otros aspectos básicos.</p>
  </header>
</app-mb-card>
<app-mb-card class="list-card">
  <header>
    <div>
      <h3>Listado de compañías</h3>
      <app-mb-button [routerLink]="['/company']">Crear compañía</app-mb-button>
    </div>
    @if (sortedCompanies?.length > 0) {
      <app-mb-table>
        <table>
          <thead>
            <tr>
              <th></th>
              <th class="sortable" (click)="setSort('companyName')">Nombre <span>{{ sortIndicator('companyName') }}</span></th>
              <th class="sortable" (click)="setSort('companyCif')">CIF <span>{{ sortIndicator('companyCif') }}</span></th>
              <th class="sortable" (click)="setSort('country')">País <span>{{ sortIndicator('country') }}</span></th>
              <th class="sortable" (click)="setSort('companyServices')">Productos <span>{{ sortIndicator('companyServices') }}</span></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (company of sortedCompanies; track company) {
              <tr>
                <td [title]="company.active ? 'Activado' : 'Desactivado'">
                  @if (company.active) {
                    <i class="fas fa-check-circle"></i>
                  }
                  @if (!company.active) {
                    <i class="fas fa-times"></i>
                  }
                </td>
                <td [title]="company.companyName">{{ company.companyName }}</td>
                <td [title]="company.companyCif">{{ company.companyCif }}</td>
                <td [title]="company.country">{{ company.country }}</td>
                <td [title]="company.companyServices">{{ company.companyServices }}</td>
                <td class="options">
                  <app-mb-button flat tooltip="companyMenu">
                    <i class="fas fa-ellipsis-h"></i>
                  </app-mb-button>
                  <app-mb-tooltip class="companyMenu">
                    <app-mb-button flat [routerLink]="['/company', company.internalId]">Ver</app-mb-button>
                    <app-mb-button flat error (click)="deleteCompany(company)">Eliminar</app-mb-button>
                  </app-mb-tooltip>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </app-mb-table>
    }
  </header>
</app-mb-card>
@if (pendingDeleteCompany) {
  <app-mb-confirm-dialog
    [title]="'Eliminar compañía'"
    [message]="'¿Seguro que quieres eliminar ' + (pendingDeleteCompany.companyName || 'esta compañía') + '? Esta acción no se puede deshacer.'"
    [confirmText]="'Eliminar'"
    [cancelText]="'Cancelar'"
    (confirmed)="confirmDeleteCompany()"
    (cancelled)="cancelDeleteCompany()"
  ></app-mb-confirm-dialog>
}
